class Footer {
  constructor(wWidth) {
    this.wWidth = wWidth;
    this.$footer = $('.footer');
    this.$menusWrap = this.$footer.find('.footer__menu-wrap');
    this.$btns = this.$menusWrap.find('.footer__btn');
    this.$menus = this.$menusWrap.find('.footer__menu');
    this.isMenuOpened = false;

    this.init();
  }

  init() {
    this.$btns.on('click', (e) => {
      const $cur = $(e.currentTarget);
      const $menuWrap = $cur.closest('.footer__menu-wrap');
      const $menu = $menuWrap.children('.footer__menu');

      // close current menu
      if ($menuWrap.hasClass('is-opened')) {
        $menuWrap.removeClass('is-opened');
        $menu.slideUp(300);

        this.isMenuOpened = false;
      } else {
        // close any opened menu
        if (this.isMenuOpened) {
          this.$menusWrap.removeClass('is-opened');
          this.$menus.slideUp(300);
        }

        // open clicked menu
        $menuWrap.addClass('is-opened');
        $menu.slideDown(300);

        this.isMenuOpened = true;
      }
    });
  }

  onResize(wWidth) {
    this.wWidth = wWidth;

    if (this.wWidth > 767) {
      this.$menusWrap.removeClass('is-opened');
      this.$menus.removeAttr('style');
      this.isMenuOpened = false;
    }
  }
}

export default Footer;
